import {
  ChevronDownIcon,
  ChevronRightIcon,
} from '@flex-design-system/legacy-flex-icons';
import { styled } from '@flex-design-system/stitches-react';
import { Stack } from '@flex-design-system/utils-style';
import { Primitive } from '@radix-ui/react-primitive';
import type { ReactNode } from 'react';

import ItemHeaderDragButton from './DragButton';
import { MoreDropdown } from './MoreDropdown';

export interface CandidateBackgroundListItemHeaderProps {
  leftSlot?: ReactNode;
  centerSlot?: ReactNode;
  rightSlot?: ReactNode;
  expanded?: boolean;
  onClick?: VoidFunction;
}

function CandidateBackgroundListItemHeader({
  leftSlot,
  centerSlot,
  rightSlot,
  expanded,
  onClick,
}: CandidateBackgroundListItemHeaderProps) {
  return (
    <ItemHeaderRoot align="center" justify="space-between" onClick={onClick}>
      <Stack.Horizontal align="center" space={10}>
        {leftSlot}
        {centerSlot}
      </Stack.Horizontal>
      <Stack.Horizontal align="center" space={10}>
        <Primitive.div onClick={e => e.stopPropagation()}>
          {rightSlot}
        </Primitive.div>
        {expanded ? (
          <ChevronDownIcon size={22} color="gray" />
        ) : (
          <ChevronRightIcon size={22} color="gray" />
        )}
      </Stack.Horizontal>
    </ItemHeaderRoot>
  );
}

const ItemHeaderRoot = styled(Stack.Horizontal, {
  px: '14px',
  py: '12px',

  borderRadius: '8px',

  clickable: 'default',
});

CandidateBackgroundListItemHeader.DragButton = ItemHeaderDragButton;
CandidateBackgroundListItemHeader.MoreDropdown = MoreDropdown;

export default CandidateBackgroundListItemHeader;
